import React from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";

import { Shelf as ShelfComponent } from "components/series-shelf/Shelf";
import { Form } from "components/series-shelf/Form";
import { Details } from "components/series-shelf/Details";

export function Shelf() {
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            highlights: action.highlights.map((h) => {
              return {
                ...h,
                rank: h.rank[0].rank,
              };
            }),
            reorderHighlights: action.highlights.map((h) => {
              return {
                ...h,
                rank: h.rank[0].rank,
              };
            }),
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "REORDER_CLICKED":
          return {
            ...s,
            showReorder: true,
          };
        case "REORDER_CANCEL":
          return {
            ...s,
            showReorder: false,
          };
        case "UP_ORDER_CLICKED":
          const newHighlights = reorder(
            action.highlight,
            action.nextRank,
            s.reorderHighlights
          );
          return {
            ...s,
            reorderHighlights: newHighlights,
          };
        case "DOWN_ORDER_CLICKED":
          const orderedHighlights = reorder(
            action.highlight,
            action.nextRank,
            s.reorderHighlights
          );
          return {
            ...s,
            reorderHighlights: orderedHighlights,
          };
        case "SAVE_ORDER":
          return {
            ...s,
            isProcessing: true,
            isError: false,
          };
        case "SAVE_ORDER_SUCCESS":
          return {
            ...s,
            highlights: s.reorderHighlights.slice(),
            isProcessing: false,
            isError: false,
            showReorder: false,
          };
        case "SAVE_ORDER_ERROR":
          console.log(action.error);
          return {
            ...s,
            isError: true,
            isProcessing: false,
          };
        case "DELETE_SUCCESS":
          return {
            ...s,
          };
        case "DELETE_ERROR":
          console.log(action.error);
          return {
            ...s,
            isError: true,
          };
        default:
          return s;
      }
    },
    {
      highlights: [],
      reorderHighlights: [],
      showReorder: false,
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const responses = await fetchShelfPageData();
        dispatch({
          type: "FETCH_SUCCESS",
          highlights: responses[0].data,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, []);

  const onSaveReorder = async () => {
    try {
      await updateHighlightOrder(state.reorderHighlights);
      dispatch({ type: "SAVE_ORDER_SUCCESS" });
    } catch (e) {
      console.error(e);
      dispatch({ type: "SAVE_ORDER_ERROR", error: e });
    }
  };
  const onDeleteHighlight = async (id) => {
    try {
      await deleteHighlight(id);
      const responses = await fetchShelfPageData();
      dispatch({
        type: "FETCH_SUCCESS",
        highlights: responses[0].data,
      });
    } catch (error) {
      dispatch({ type: "DELETE_ERROR", error });
    }
  };
  return (
    <ShelfComponent
      highlights={state.highlights}
      reorderHighlights={state.reorderHighlights}
      showReorder={state.showReorder}
      onDeleteHighlight={onDeleteHighlight}
      onReorderClick={() => {
        dispatch({ type: "REORDER_CLICKED" });
      }}
      onReorderCancelClick={() => {
        dispatch({ type: "REORDER_CANCEL" });
      }}
      onUpOrderClick={(highlight, nextRank) => {
        dispatch({ type: "UP_ORDER_CLICKED", highlight, nextRank });
      }}
      onDownOrderClick={(highlight, nextRank) => {
        dispatch({ type: "DOWN_ORDER_CLICKED", highlight, nextRank });
      }}
      onSaveOrderClick={onSaveReorder}
    />
  );
}

export function HighlightForm() {
  const history = useHistory();
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            programList: action.programList,
            templateList: action.templateList,
            template: action.templateList[0].id,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "ADD_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: [...s.pickedProgramList, action.program],
            programList: s.programList.filter(
              (p) => p.id !== action.program.id
            ),
          };
        case "REMOVE_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: s.pickedProgramList.filter(
              (p) => p.id !== action.program.id
            ),
            programList: [...s.programList, action.program],
          };
        case "REORDER_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: action.list,
          };
        case "CREATE_HIGHLIGHT":
          return {
            ...s,
            isProcessing: true,
            isError: false,
          };
        case "CREATE_HIGHLIGHT_SUCCESS":
          history.push("/series-shelf/");
          break;
        case "CREATE_HIGHLIGHT_ERROR":
          console.log(action.error);
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "FETCH_PROGRAM_SUCCESS":
          return {
            ...s,
            programList: action.programList,
          };
        case "SET_TITLE":
          return {
            ...s,
            title: action.title,
          };
        case "SET_TEMPLATE":
          return {
            ...s,
            template: action.template,
          };
        default:
          return s;
      }
    },
    {
      programList: [],
      templateList: [],
      pickedProgramList: [],
      title: "",
      template: "",
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const resp = await fetchFormPageData();
        dispatch({
          type: "FETCH_SUCCESS",
          programList: resp[1].data,
          templateList: resp[0].data,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, []);

  const onSetTitle = (title) => {
    dispatch({ type: "SET_TITLE", title });
  };

  const onSetTemplate = (template) => {
    dispatch({ type: "SET_TEMPLATE", template });
  };

  const onPickProgram = (program) => {
    dispatch({
      type: "ADD_PICKED_PROGRAM",
      program,
    });
  };
  const onRemovePickedProgram = (program) => {
    dispatch({
      type: "REMOVE_PICKED_PROGRAM",
      program,
    });
  };
  const onReorderPickedProgram = (program, current, next) => {
    const list = state.pickedProgramList.map((p, index) => {
      if (index === next) {
        return {
          ...program,
        };
      } else if (index === current) {
        return {
          ...state.pickedProgramList[next],
        };
      } else {
        return p;
      }
    });
    dispatch({
      type: "REORDER_PICKED_PROGRAM",
      list,
    });
  };
  const onFetchPrograms = async (title) => {
    try {
      const resp = await fetchProgramAndContentByTitle(title);
      dispatch({
        type: "FETCH_PROGRAM_SUCCESS",
        programList: resp.data,
      });
    } catch (e) {
      console.log(e);
    }
  };
  const onSubmit = async (data) => {
    try {
      dispatch({ type: "CREATE_HIGHLIGHT" });
      const resp = await createHighlight({
        title: state.title,
        template: state.template,
        programs: state.pickedProgramList,
      });
      if (resp.data && resp.data.name === "error") {
        throw new Error(resp.data.detail);
      }
      dispatch({ type: "CREATE_HIGHLIGHT_SUCCESS" });
    } catch (e) {
      console.log(e);
      dispatch({ type: "CREATE_HIGHLIGHT_ERROR", error: e });
    }
  };
  return (
    <Form
      templateList={state ? state.templateList : []}
      pickedPrograms={state ? state.pickedProgramList : []}
      programs={state ? state.programList : []}
      title={state ? state.title : ""}
      template={state ? state.template : ""}
      onSetTitle={onSetTitle}
      onSetTemplate={onSetTemplate}
      onPickProgram={onPickProgram}
      onRemovePickedProgram={onRemovePickedProgram}
      onReorderPickedProgram={onReorderPickedProgram}
      onFetchPrograms={onFetchPrograms}
      onSubmit={onSubmit}
    />
  );
}

export function HighlightDetails() {
  const history = useHistory();
  const params = useParams();
  const [state, dispatch] = React.useReducer(
    (s, action) => {
      switch (action.type) {
        case "FETCH_SUCCESS":
          return {
            ...s,
            highlight: action.highlight,
            programList: action.programList,
            pickedProgramList: action.pickedProgramList,
            templateList: action.templateList,
            template: action.highlight.template,
            title: action.highlight.title,
            isProcessing: false,
            isError: false,
          };
        case "FETCH_ERROR":
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "ADD_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: [...s.pickedProgramList, action.program],
            programList: s.programList.filter(
              (p) => p.id !== action.program.id
            ),
          };
        case "REMOVE_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: s.pickedProgramList.filter(
              (p) => p.id !== action.program.id
            ),
            programList: [...s.programList, action.program],
          };
        case "REORDER_PICKED_PROGRAM":
          return {
            ...s,
            pickedProgramList: action.list,
          };
        case "UPDATE_HIGHLIGHT":
          return {
            ...s,
            isProcessing: true,
            isError: false,
          };
        case "UPDATED_HIGHLIGHT_SUCCESS":
          history.push("/series-shelf/");
          break;
        case "UPDATED_HIGHLIGHT_ERROR":
          console.log(action.error);
          return {
            ...s,
            isProcessing: false,
            isError: true,
          };
        case "FETCH_PROGRAM_SUCCESS":
          return {
            ...s,
            programList: action.programList,
          };
        case "SET_TITLE":
          return {
            ...s,
            title: action.title,
          };
        case "SET_TEMPLATE":
          return {
            ...s,
            template: action.template,
          };
        default:
          return s;
      }
    },
    {
      highlight: {},
      programList: [],
      templateList: [],
      pickedProgramList: [],
      title: "",
      template: "",
      isProcessing: true,
      isError: false,
    }
  );
  React.useEffect(() => {
    const f = async () => {
      try {
        const resp = await fetchHighlightDetailsData(params.id);
        if (resp[0].data.length === 0) {
          throw new Error(`Highlight ID: ${params.id} not found.`);
        }
        dispatch({
          type: "FETCH_SUCCESS",
          highlight: resp[0].data[0],
          pickedProgramList: resp[2].data,
          templateList: resp[1].data,
          programList: resp[3].data,
        });
      } catch (e) {
        console.error(e);
        dispatch({
          type: "FETCH_ERROR",
        });
      }
    };

    f();
  }, [params.id]);

  const onSetTitle = (title) => {
    dispatch({ type: "SET_TITLE", title });
  };

  const onSetTemplate = (template) => {
    dispatch({ type: "SET_TEMPLATE", template });
  };

  const onPickProgram = (program) => {
    dispatch({
      type: "ADD_PICKED_PROGRAM",
      program,
    });
  };
  const onRemovePickedProgram = (program) => {
    dispatch({
      type: "REMOVE_PICKED_PROGRAM",
      program,
    });
  };
  const onReorderPickedProgram = (program, current, next) => {
    const list = state.pickedProgramList.map((p, index) => {
      if (index === next) {
        return {
          ...program,
        };
      } else if (index === current) {
        return {
          ...state.pickedProgramList[next],
        };
      } else {
        return p;
      }
    });
    dispatch({
      type: "REORDER_PICKED_PROGRAM",
      list,
    });
  };
  const onFetchPrograms = async (title) => {
    try {
      const resp = await fetchAvailableProgram(state.highlight.id, title);
      dispatch({
        type: "FETCH_PROGRAM_SUCCESS",
        programList: resp.data,
      });
    } catch (e) {
      console.log(e);
    }
  };
  const onSubmit = async (data) => {
    try {
      dispatch({ type: "UPDATE_HIGHLIGHT" });
      const resp = await updateHighlight({
        title: state.title,
        highlight: state.highlight.id,
        template: state.template,
        programs: state.pickedProgramList,
      });
      if (resp.data && resp.data.name === "error") {
        throw new Error(resp.data.detail);
      }
      dispatch({ type: "UPDATED_HIGHLIGHT_SUCCESS" });
    } catch (e) {
      console.log(e);
      dispatch({ type: "UPDATED_HIGHLIGHT_ERROR", error: e });
    }
  };
  return (
    <Details
      highlight={state ? state.highlight : {}}
      templateList={state ? state.templateList : []}
      pickedPrograms={state ? state.pickedProgramList : []}
      programs={state ? state.programList : []}
      title={state ? state.title : ""}
      template={state ? state.template : ""}
      onSetTitle={onSetTitle}
      onSetTemplate={onSetTemplate}
      onPickProgram={onPickProgram}
      onRemovePickedProgram={onRemovePickedProgram}
      onReorderPickedProgram={onReorderPickedProgram}
      onFetchPrograms={onFetchPrograms}
      onSubmit={onSubmit}
    />
  );
}

async function fetchShelfPageData() {
  const shelfRequest = axios.get(
    "/r-api/series_highlight?select=*,rank:series_highlight_rank(rank)"
  );
  return axios.all([shelfRequest]);
}

async function fetchFormPageData() {
  const layoutRequest = axios.get("/r-api/layout_template?order=id");
  const contentRequest = axios.get(
    `/program-content-shelf-api/content-program/?title=`
  );
  return axios.all([layoutRequest, contentRequest]);
}

async function fetchHighlightDetailsData(id) {
  const highlightUrl = `/r-api/series_highlight?id=eq.${id}`;
  const highlightRequest = axios.get(highlightUrl);
  const programUrl = `/program-content-shelf-api/series_highlight_content/?highlight=${id}`;
  const programRequest = axios.get(programUrl);
  const layoutRequest = axios.get("/r-api/layout_template?order=id");
  const availableRequest = axios.get(
    `/program-content-shelf-api/available-program-content/?highlight=${id}&title=`
  );
  return axios.all([
    highlightRequest,
    layoutRequest,
    programRequest,
    availableRequest,
  ]);
}

async function fetchProgramAndContentByTitle(title) {
  return axios.get(
    `/program-content-shelf-api/content-program/?title=${title}`
  );
}

async function fetchAvailableProgram(highlight, title) {
  const url = `/program-content-shelf-api/available-program-content/?highlight=${highlight}&title=${title}`;
  return axios.get(url);
}

async function updateHighlightOrder(highlights) {
  const highlightRank = highlights.map((h) => {
    return {
      highlight: h.id,
      rank: h.rank,
    };
  });

  return axios.put(
    "/program-content-shelf-api/series_highlight_rank/",
    highlightRank
  );
}

async function updateHighlight(highlight) {
  return axios.put("/program-content-shelf-api/series_highlight", highlight);
}

async function createHighlight(highlight) {
  return axios.post("/program-content-shelf-api/series_highlight", highlight);
}

async function deleteHighlight(id) {
  const url = `/program-content-shelf-api/series_highlight/${id}/`;
  return axios.delete(url);
}

function reorder(highlight, nextRank, highlights) {
  if (nextRank < 1 || nextRank === highlights.length + 1) {
    return highlights;
  }

  const newHighlights = highlights.map((h) => {
    if (highlight.id === h.id) {
      return {
        ...h,
        rank: nextRank,
      };
    } else if (h.rank === nextRank) {
      return {
        ...h,
        rank: highlight.rank,
      };
    } else {
      return h;
    }
  });

  return newHighlights;
}
